module.exports = __webpack_public_path__ + "img/level03.ee9d1933.png";